var map = {
	"./demos/basic/index.ts": 53203,
	"./demos/container/index.ts": 92754,
	"./demos/events/index.ts": 56026,
	"./demos/horizontal/index.ts": 59683,
	"./demos/nested/index.ts": 26492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9994;